import { useContext } from "react";
import { BarChart3, FileText } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { RelatorioProdutosContext } from "../context/RelatorioProdutosContext";
import ContainerFilters from "./ContainerFilters";
import GroupCard from "./GroupCard";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { report } = useContext(RelatorioProdutosContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1 mb-6">
                            <span className="label-overline">Análise</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Relatório de Produtos
                                <BarChart3 className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Performance consolidada por grupo de produtos — vendas, ROI e investimento.
                            </p>
                        </div>
                        <ContainerFilters />
                    </header>

                    {report?.grupos ? (
                        <div className="space-y-4 animate-slide-up">
                            {report.grupos.map(grupo => (
                                <GroupCard key={grupo.id} grupo={grupo} />
                            ))}
                            {report.grupos.length === 0 && (
                                <EmptyState
                                    icon={<FileText className="h-10 w-10" />}
                                    title="Nenhum grupo encontrado"
                                    body="Tente ajustar o período ou criar grupos em Catálogo → Grupos."
                                />
                            )}
                        </div>
                    ) : (
                        <EmptyState
                            icon={<BarChart3 className="h-10 w-10" />}
                            title="Selecione um período"
                            body="Escolha datas inicial e final, depois clique em Buscar."
                        />
                    )}

                </div>
            </div>
        </div>
    );
}


function EmptyState({ icon, title, body }) {
    return (
        <div className="surface-card p-12 grid place-items-center text-center">
            <div className="text-ink-5 mb-3">{icon}</div>
            <h3 className="heading-3 mb-1">{title}</h3>
            <p className="text-sm text-ink-4 max-w-sm">{body}</p>
        </div>
    );
}
